<script lang="ts">
  import { afterUpdate } from 'svelte';

  export let width = 20;
  export let height = 20;
  export let focusable = false;
  export let classes = '';

  let sizeInRem = 0;

  function calculateTransformOrigin() {
    sizeInRem = width / 2 / 16;
  }

  afterUpdate(() => {
    calculateTransformOrigin();
  });
</script>

<svg
  class="{classes}"
  width="{width}px"
  height="{width}px"
  fill="none"
  focusable="{`${focusable}`}"
  viewBox="0 0 {width} {height}"
>
  <path
    opacity="0.2"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.99935 16.6667C13.6812 16.6667 16.666 13.6819 16.666 10C16.666 6.31812 13.6812 3.33335 9.99935 3.33335C6.31745 3.33335 3.33268 6.31812 3.33268 10C3.33268 13.6819 6.31745 16.6667 9.99935 16.6667ZM9.99935 18.3334C14.6017 18.3334 18.3327 14.6024 18.3327 10C18.3327 5.39765 14.6017 1.66669 9.99935 1.66669C5.39698 1.66669 1.66602 5.39765 1.66602 10C1.66602 14.6024 5.39698 18.3334 9.99935 18.3334Z"
    fill="currentColor"
  ></path>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    class="animate-spin"
    d="M9.99935 3.33335C6.31745 3.33335 3.33268 6.31812 3.33268 10C3.33268 13.6819 6.31745 16.6667 9.99935 16.6667C10.4596 16.6667 10.8327 17.0398 10.8327 17.5C10.8327 17.9603 10.4596 18.3334 9.99935 18.3334C5.39698 18.3334 1.66602 14.6024 1.66602 10C1.66602 5.39765 5.39698 1.66669 9.99935 1.66669C14.6017 1.66669 18.3327 5.39765 18.3327 10C18.3327 10.4603 17.9596 10.8334 17.4993 10.8334C17.0391 10.8334 16.666 10.4603 16.666 10C16.666 6.31812 13.6812 3.33335 9.99935 3.33335Z"
    fill="url(#paint0_linear_554_70008)"
    style="transform-origin: {sizeInRem}rem {sizeInRem}rem;"
  ></path>
  <defs>
    <linearGradient
      id="paint0_linear_554_70008"
      x1="9.99935"
      y1="10"
      x2="9.99935"
      y2="16.6667"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="currentColor"></stop>
      <stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
    </linearGradient>
  </defs>
</svg>
